// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-DataExtraction-ConfirmationDialog-module__ConfirmationDialog_text";
export { _1 as "ConfirmationDialog_text" }
